import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="mx-auto px-4 md:px-6 py-14 max-w-[1400px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" onClick={scrollToTop} className="inline-block mb-4">
              <span className="text-2xl font-heading text-primary-500">43423</span>
              <span className="text-sm font-body font-semibold text-foreground-800 ml-2">漫画网</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              海量免费漫画在线阅读平台，涵盖韩漫、日漫、国漫等多种类型，每日更新，下拉式流畅阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    onClick={scrollToTop}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/tuijian" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  编辑推荐
                </Link>
              </li>
              <li>
                <Link to="/category/paihang" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  排行榜
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.contact.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>{siteInfo.contact.wechat}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2020-2026 43423漫画网. 本站所有漫画均来自互联网，仅供交流学习之用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}